<template>
    <div class="contenido_todo">
    <div class="contenido_inicio">
        <menuVar></menuVar>
    </div>
    <div class="contenido_general">
        <!-- <div class="itemSlide"> -->
        <div class="contenido_principal caja_tabla ">
            <!--  <img src="vistas/dist/custom/imgs/home.png" class="imgEquipoLog" data-aos="fade-right" data-aos-duration="1500"> -->
            <!-- Contenido -->
            <div class="contenedor_contenido">
                <div class="titulo_inicial">
                    <h1 class="titleSlide log">¡Ser un socio ChevronCard te da beneficios!</h1>
                </div>

                <div :class="[slideActivo ? 'contenedor_dividido_slide' : 'contenedor_centrado']">
                    <div class="contenido_texto"
                        :class="{
                            'contenido_texto_centrado': !slideActivo,
                            'contenido_texto_shadow': slideActivo
                        }"
                    >

                    <div class="formulario_acceso">
                        <h2 class="titleSlide titulo_inicio">REGISTRAR USUARIO</h2>

                        <img class="img_login" src="../img/Recurso 74.png" data-aos="zoom-in"  data-aos-duration="1000">
                            <!-- v-if="!slideActivo"> -->

                        <form class="contenedor_formulario">
                            <!-- LOGIN -->
                            <div class="formulario_login">
                                <div class="formulario_seccion">
                                    <label class="formulario_label">Número de Cliente</label>
                                    <div class="form_input">
                                        <input class="grupo_input log" type="text" placeholder="Número de Cliente"
                                            maxlength="13" minlength="13" autocomplete="off" id="txt_clienteRegistro"
                                            v-model="numeroCliente" name="txt_clienteRegistro" required>
                                    </div>
                                </div>
                            </div>

                            <div class="formulario_login">
                                <div class="formulario_seccion">
                                    <label class="formulario_label">Código de Activación</label>
                                    <div class="form_input">
                                        <input class="grupo_input log" :type="showCode ? 'text' : 'password'" placeholder="Código de Activación"
                                            maxlength="13" minlength="13" autocomplete="off" id="txt_codigoRegistro"
                                            v-model="codigoActivacion" name="txt_codigoRegistro" required>
                                        
                                        <div class="contenedor_eye log" @click="sbMostrarCodigo">
                                            <span v-if="showCode" class="fa-solid fa-lock-open"></span>
                                            <i v-else class="fa-solid fa-lock"></i>
                                        </div>

                                        <!-- <div class="input-group-append">
                                            <div class="input-group-text">
                                                <span class="fas fa-lock"></span>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="contenido_btn">
                            <button id="btnVerificarCodigo" data-toggle="modal" data-target="#exampleModal"
                                type="button" @click="sbActivacion" class="btnSend log">VERIFICAR CÓDIGO</button>

                            <a class="cantidad_p" @click="sbLogin">Acceder a tu cuenta</a>
                            <b-spinner variant="primary" v-if="show"></b-spinner>
                        </div>
                        </div>
                    </div>
                    <!-- Slide -->
                    <div v-if="slideActivo" class="contenedor_slide">
                        <slideInicio @slide-activo="slideActivo = $event"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bmodal Registrar Usuario -->
        <b-modal size="md" title="Registrar Usuario" 
            v-model="modalPerfil" hide-footer centered
            dialog-class="contenedor_canjear"
            header-class="contenido_cabecera"
            content-class="contenido_modal"
        >
            <template #modal-title>
                <div class="header_modal">
                    <i class="fa-solid fa-user-check"></i>
                    <span>Registrar Usuario</span>
                </div>
            </template>

            <b-container>
                <div class="contenedor_dividido">
                    <div class="dividido">
                        <b-form-group class="contenedor_grupo" label="Usuario (# Telefono):" label-for="usuarioInput">
                            <b-form-input size="sm" class="grupo_input" id="usuarisoInput"
                                v-model="datosUsuario.usuario" name="usuario" type="text" onKeyPress="if(this.value.length==10) return false;" required >
                            </b-form-input>
                        </b-form-group>
                    </div>
                        
                    <div class="dividido">
                        <b-form-group class="contenedor_grupo" label="Contraseña:" label-for="passInput">
                            <div class="contenedor_contra">
                                <b-form-input size="sm" class="grupo_input" id="passInput" v-model="datosUsuario.pass"
                                    maxlength="8" min="2" :type="showPassword ? 'text' : 'password'">
                                </b-form-input>

                                <div class="contenedor_eye" @click="sbMostrarPass" >
                                    <span v-if="showPassword" class="fas fa-eye-low-vision"></span>
                                    <span v-else class="fas fa-eye"></span>
                                </div>
                            </div>
                        </b-form-group>

                        <!-- <button class="input-group-text" @click="sbMostrarPass" >
                            <span v-if="showPassword" class="fas fa-eye-low-vision"></span>
                            <span v-else class="fas fa-eye"></span>
                        </button> -->
                        
                    </div>
                </div>

                <b-form-group class="contenedor_grupo" label="Nombre Usuario:" label-for="nombreInput">
                    <b-form-input class="grupo_input" size="sm" id="nombreInput" type="text"
                        v-model="datosUsuario.nombreUsuario">
                    </b-form-input>
                </b-form-group>
                <b-form-group class="contenedor_grupo" label="Correo:" label-for="correoInput">
                    <b-form-input class="grupo_input" size="sm" id="correoInput" type="email"
                        v-model="datosUsuario.correo">
                    </b-form-input>
                </b-form-group>

                <button class="btnAceptar1" @click="sbGuardarUsuario" style="width: 100%;"> Guardar
                </button>

            </b-container>
        </b-modal>

    </div>
    </div>
</template>

<script>
import servicioCliente from '../services/servicioCliente'
import menuVar from '../components/navBar.vue'
import slideInicio from '@/components/slideInicio.vue';
export default {
    components: {
        menuVar,slideInicio
    },
    data() {
        return {
            facturar: false,
            activacion: [],
            codigoActivacion: '',
            modalPerfil: false,
            datosUsuario: {
                usuario: '',
                pass: '',
                nombreUsuario: '',
                clienteID: 0,
                numeroCliente: '',
                rfc: '',
                nombre: '',
                calle: '',
                colonia: '',
                ciudad: '',
                codigoPostal: '',
                noInterior: '',
                noExterior: '',
                localidad: '',
                estado: '',
                regimenFiscalID: 1,
                descripcion: '',
                correo: ''

            },
            clienteID: 0,
            numeroCliente: '',
            idRegimen: null,
            show:false,
            showPassword:false,
            showCode:false,
            slideActivo:true

        }
    },
    methods:
    {
        async sbGuardarUsuario() {
            var mensaje = ''
            if (this.datosUsuario.usuario.length < 10) {
                mensaje = 'El usuario  debe de ser de 10 digitos'
                this.$msg.warning(mensaje)
                return
            }

            if (this.datosUsuario.usuario.length > 10) {
                mensaje = 'El usuario debe de ser de 10 digitos'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.pass.toString().trim() == "") {
                mensaje = 'La contraseña no debe de estar en blanco'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.nombreUsuario.toString().trim() == "") {
                mensaje = 'El nombre de usuario no debe de estar en blanco'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.usuario.substring(0,8).toString() == this.datosUsuario.pass)
            {
                mensaje = 'EL usuario es muy similar a su contraseña , favor de cambiar.'
                this.$msg.info(mensaje)
                return
            }

            if (this.datosUsuario.correo.toString().trim() == "") {
                mensaje = 'El correo no debe de estar en blanco, este dato es importante para poder recuperar su contraseña!!.'
                this.$msg.info(mensaje)
                return
            }

            if (!(this.sbValidEmail(this.datosUsuario.correo.toString())))
            {
                mensaje = 'El correo debe de ser valido !!.'
                this.$msg.info(mensaje)
                return
            }
            

            var respuestaUsuario = await servicioCliente.existeNoUsuario(this.datosUsuario.usuario)
            if (respuestaUsuario.data.length > 0) {
                if (respuestaUsuario.data[0].respuesta == "Usuario ya registrado") {
                    mensaje = 'Usuario ya registrado'
                    this.$msg.info(mensaje)
                    return
                }
            }

            this.datosUsuario.clienteID = this.clienteID
            this.datosUsuario.numeroCliente = this.numeroCliente
            this.datosUsuario.idRegimen = this.idRegimen;

            var respuesta = await servicioCliente.activarTarjeta(this.datosUsuario)
            if (respuesta.value == true) {
                mensaje = 'Tarjeta Activada Exitosamente.'
                this.$msg.success(mensaje)
                this.numeroCliente =""
                this.codigoActivacion=""
                this.modalPerfil = false

            }
            else {

                mensaje = 'No se pudo activar la tarjeta.. favor de contactar al Servicio al Cliente.'
                this.$msg.error(mensaje)
            }
        },

        sbMostrarPass() {
            if(this.showPassword) {
                this.showPassword=false
            } else {
                this.showPassword=true
            }
        },

        sbLimpiar(){
            this.datosUsuario = {
                usuario: '',
                pass: '',
                nombreUsuario: '',
                clienteID: 0,
                numeroCliente: '',
                rfc: '',
                nombre: '',
                calle: '',
                colonia: '',
                ciudad: '',
                codigoPostal: '',
                noInterior: '',
                noExterior: '',
                localidad: '',
                estado: '',
                regimenFiscalID: 1,
                descripcion: '',
                correo: ''
            }
        },

        sbLogin() {
            this.$router.push({ name: "loginV" });
        },

        async sbActivacion() {
            var mensaje = ''
            this.show= true
            this.sbLimpiar()

            if (this.numeroCliente.toString().trim() == "") {
                mensaje = 'Falta el numero de cliente'
                this.$msg.info(mensaje)
                this.show= false
                return
            }

            if (this.codigoActivacion.toString().trim() == "") {
                mensaje = 'Falta el codigo de activacion'
                this.show= false
                this.$msg.info(mensaje)
                return
            }

            var respuesta = await servicioCliente.datosActivacion(this.numeroCliente, this.codigoActivacion)

            if (respuesta.value == true) {
                this.activacion = respuesta.data

                if (this.activacion.length > 0) {

                    if (this.activacion[0].estatus == '0') {
                        this.clienteID = this.activacion[0].clienteID
                        this.numeroCliente = this.activacion[0].numeroCliente
                        this.modalPerfil = true

                    }
                    else {
                        mensaje = this.activacion[0].mensaje
                        this.$msg.info(mensaje)
                    }
                }
                else {
                    mensaje = 'No se encontro información de la tarjeta.'
                    this.$msg.info(mensaje)
                }
            }
            else {
                this.$msg.info(respuesta.message)

            }
            this.show= false
        },

        sbValidEmail: function (email) {
            var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return regex.test(email);
        },

        sbMostrarCodigo(){
            if (this.showCode){
                this.showCode = false
            } else {
                this.showCode = true
            }
        },
    }
}
</script>

<style scoped>
.titulo_inicio{
    font-size: 20px;
    text-align: center;
}
.titleSlide{
    margin-bottom: 20px;
}
.itemSlide {
    background-color: #fff;
    padding: 20px;
}

.contenido_btn{
    justify-content: space-between;
    gap: 10px;
}

.contenedor_formulario{
    gap: 15px;
}

.formulario_login{
    width: 100%;
    gap: 10px;
}

.form_input{
    position: relative;
    width: 100%;
}

.input-group-text{
    border-radius: 10px;
}

.grupo_input.log{
    height: 35px;
    border-radius: 14px;
    border: 1px solid #d7e0ea;
    background: #f8fafc;
    transition: .25s;
    text-transform: none;
}

.tituloEt:hover {
    cursor: pointer;
}

.contenido_btn{
    justify-content: space-between;
    gap: 15px;
}


/* .caja_titulo h1{
    color: #0073BC;
} */



.cantidad_p{
    text-decoration: underline !important;
    cursor: pointer;
    padding: 2px 8px;
    color: #dc2626 !important;
    font-weight: 700;
    transition: .2s;
}

.cantidad_p:hover{
    background: #F8C7BF;
    border-radius: 12px;
}

.contenedor_dividido{
    justify-content: center;
}

.btnAceptar1 {
    margin: 10px 0;
}

@media(max-width:768px){

    .contenido_principal{
        padding: 20px;
    }

    .titulo_inicial h1{
        font-size: 1.3rem;
    }

    .contenido_texto{
        padding: 35px;
    }

    .titulo_inicio{
        font-size: 1.2rem;
    }

    .grupo_input.log{
        height: 30px;
    }

    .btnSend.log{
        height: 30px;
        width: 100%;
    }

    .contenedor_slide{
        min-height: 270px;
    }
}



</style>